'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function hasSessionStorage() {
  try {
    sessionStorage.setItem("x-session-test", "available");
    sessionStorage.removeItem("x-session-test");
    return true;
  } catch (e) {
    return false;
  }
}
function hasLocalStorage() {
  try {
    localStorage.setItem("x-local-test", "available");
    localStorage.removeItem("x-local-test");
    return true;
  } catch (e) {
    return false;
  }
}
function setItem(key, data) {
  try {
    window.localStorage.setItem(key, JSON.stringify(data));
  } catch (e) {
    console.error("localStorage", e);
  }
}
function removeItem(key) {
  try {
    window.localStorage.removeItem(key);
  } catch (e) {
    console.error("localStorage", e);
  }
}
function getItem(key) {
  const data = window.localStorage.getItem(key);
  return data === null ? data : JSON.parse(data);
}

exports.getItem = getItem;
exports.hasLocalStorage = hasLocalStorage;
exports.hasSessionStorage = hasSessionStorage;
exports.removeItem = removeItem;
exports.setItem = setItem;
